import {
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    ColumnDef,
    flexRender,
} from '@tanstack/react-table';
import { NSTable } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';
import { useProFormaSocketContext } from '../../socketContext/ProFormaSocketProvider';
import './BaseTotalsTable.scss';

export interface IBaseTotalsTableProps {
    tableName: string;
    totalAmount: number;
    cashFlowValues: any[];
    operationBeginIndex: number;
    baseCashFlowColumns: ColumnDef<any>[];
}

const BaseTotalsTable = ({
    tableName, totalAmount, cashFlowValues, operationBeginIndex, baseCashFlowColumns,
}: IBaseTotalsTableProps) => {
    const { showCents, formatDisplayValue, proForma } = useProFormaSocketContext();

    const cashFlowColumns: ColumnDef<any>[] = baseCashFlowColumns.map((column, cashFlowIndex) => ({
        ...column,
        id: `totals-period-${column.id}`,
        footer: () => (
            <RenderIf isTrue={operationBeginIndex}>
                <span className="text-dark">
                    {formatDisplayValue(cashFlowValues[cashFlowIndex] || 0, showCents, 'currency')}
                </span>
            </RenderIf>
        ),
    }));

    const columns: ColumnDef<any>[] = [
        {
            accessorKey: 'name',
            id: 'name',
            footer: () => <span>{tableName}</span>,
        },
        {
            accessorKey: 'totalAmount',
            id: 'totalAmount',
            footer: () => <span>{formatDisplayValue(totalAmount || 0, showCents, 'currency')}</span>,
        },
        ...cashFlowColumns,
    ];

    const table = useReactTable({
        data: [],
        columns,
        getCoreRowModel: getCoreRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
    });

    return (
        <NSTable className={`NSTable BaseTotalsTable--${proForma.proFormaModelName?.replace(/ /g, '-')} mb-1`}>
            <tfoot className="NSTable__tfoot">
                {table.getFooterGroups().map(footerGroup => (
                    <tr key={footerGroup.id} className="NSTable__tfoot__tr">
                        {footerGroup.headers.map(header => (
                            <th key={header.id} className="NSTable__tfoot__tr__th py-1 px-2">
                                {flexRender(
                                    header.column.columnDef.footer,
                                    header.getContext(),
                                )}
                            </th>
                        ))}
                    </tr>
                ))}
            </tfoot>
        </NSTable>
    );
};

export default BaseTotalsTable;
